import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pesc-grid',
  templateUrl: './pesc-grid.component.html',
  styleUrls: ['./pesc-grid.component.css']
})
export class PescGridComponent implements OnInit {

  title = "Project Environment and Safety Compilance";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/pe-sc/pesc-grid/pesc-grid.component.ts